import { render, staticRenderFns } from "./derivatives-knowledge-result.vue?vue&type=template&id=6a1c5f7b&scoped=true&"
import script from "./derivatives-knowledge-result.vue?vue&type=script&lang=js&"
export * from "./derivatives-knowledge-result.vue?vue&type=script&lang=js&"
import style0 from "./derivatives-knowledge-result.vue?vue&type=style&index=0&id=6a1c5f7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c5f7b",
  null
  
)

component.options.__file = "derivatives-knowledge-result.vue"
export default component.exports